import React from 'react'
import { graphql } from 'gatsby'

import './style.scss'

import MassiveTitle from '../MassiveTitle/index'

const Expertise = ({ data }) => {
  const {
    html,
    frontmatter: {
      title,
      intro_title: introTitle,
      expertise_items: expertiseItems,
    },
  } = data

  return (
    <section>
      <div className="c-expertise-container container px-lg-5 position-relative text-center text-sm-left">
        <div className="u-pull-up">
          <MassiveTitle modifiers={['left']}>{title}</MassiveTitle>
        </div>
        <div className="row">
          <div className="col-sm-8">
            <h6 className="text-left">{introTitle}</h6>
            <h2>{title}</h2>
            <div dangerouslySetInnerHTML={{ __html: html }} />
          </div>
        </div>
      </div>

      <div className="container mt-3 position-relative">
        <div className="row">
          {expertiseItems.map((topic, index) => {
            const {
              frontmatter: { title, color, icon },
              html,
              id,
            } = topic.childMarkdownRemark
            return (
              <div className="col-sm-6 col-md-3 position-static" key={title}>
                <article
                  className={`c-expertise-item text-center text-sm-left mb-4 mb-sm-0 ${index ===
                    0 && 'is-first'}`}
                >
                  <div className="">
                    <img
                      className="m-auto w-25 d-block"
                      src={icon.childImageSharp.original.src}
                      alt={title}
                    />
                  </div>
                  {index === 0 && (
                    <div className="c-expertise-item__line my-3 d-none d-md-block" />
                  )}
                  <div
                    className="c-expertise-item__dot mx-auto my-3"
                    style={{ color: color }}
                  />
                  <h3 className="text-center">{title}</h3>
                  <div dangerouslySetInnerHTML={{ __html: html }} />
                </article>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Expertise

export const ExpertiseQuery = graphql`
  fragment expertise on Query {
    expertise: markdownRemark(frontmatter: { id: { eq: "about_expertise" } }) {
      frontmatter {
        intro_title
        title
        expertise_items {
          childMarkdownRemark {
            id
            frontmatter {
              color
              title
              icon {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
            html
          }
        }
      }
      html
    }
  }
`
